import React from "react";

export const ArrowRightTabIcon = React.memo(() => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.25 17.5L13.75 10L6.25 2.5" stroke="var(--messenger-grey-1)" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
});